module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.0.0.box.451.202.867.278.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.14.0.0.box.820.202.114.40.q.0"
    }
  }, [_c('span', {
    staticClass: "Apple-style-span",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.14.0.1.box.592.315.573.93.q.70"
    }
  }, [_vm._v("THE MOTHER: CHARLOTTE S. BRANCH")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.14.0.2.box.451.433.867.47.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mother ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Oglethorpe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Light ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Infantry")]), _vm._v("\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.1.0.box.740.528.279.101.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.14.1.0.box.861.528.37.42.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.0.0"
    }
  }), _vm._v("By ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.14.1.1.box.740.588.279.41.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mauriel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("P. ")]), _c('i', [_vm._v("Joslyn ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.2.0.box.217.703.1327.1687.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.2.0.box.217.703.1321.156.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.0.0"
    }
  }), _vm._v("On April 10, 1861, only days before Fort Sumter found its place in history, a 46-year old widow sat down to write a reply to a letter from her oldest son:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.2.1.box.217.884.1321.637.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.1.0"
    }
  }), _vm._v("\"I am satisfied now that there will be war and if there is, I would not have the slightest obstacle in the way to prevent my sons from going where duty called them, no not if my heart should brake.\""), _c('sup', [_vm._v("1")]), _vm._v(" The recipient of the letter, John Branch, was 23 years old, a newly commissioned lieutenant in the distinguished Savannah militia company, the Oglethorpe Light Infantry. He was then at Fort Pulaski in the mouth of the Savannah River, a part of the troops who had occupied the fort in January 1861. Two younger brothers, Sanford age 21, and Hamilton age 18, had also enlisted in the company. Their mother, Charlotte Sawyer Branch, was about to send them off to battle with her blessings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.2.2.box.217.1535.1327.554.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.2.0"
    }
  }), _vm._v("Charlotte was born in 1814, the only child of Sarah McDevit and Walker Colburn Sawyer. Sarah McDevit had come to America from Ireland, and married Walker Sawyer, a New Hampshire sailor. When Charlotte was four years old, her father died at sea, leaving his family to make their own way in the world. So Charlotte became acquainted with adversity at an early age. Little is known of her childhood. Her education was typical of the children of her social class. She wrote a short letter to her son upon his inquiry about the infamous 1854 yellow fever epidemic. Her reply gives us a glimpse of her life as a child:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    attrs: {
      "id": "para.14.2.3.box.368.2173.1020.217.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.4.0.0"
    }
  }), _vm._v("I was a very little child when the Yellow Fever raged in Sav. in 1820. (it was caused by the dreadful rains after the great fire when so large a portion of the citty was laid in ruins.) Many of the buildings had deep"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.1.0.box.375.309.1020.927.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  }), _vm._v("\ncellars in which were large quantities of vegatable matter which had been partially burned the rains filled these cellars and rotted the contents of them which [generated] feaver, that I have heard from the old Folks who new all about it. I was born in this citty and never saw a case of Yellow Fever until the summer of 1854, when we had it in Savannah as an Epidemic for the first time in my recolections (when I was about 11 years of age I remember that it raged there were 8 cases in full near where I went to school but I did not think any one was alarmed about it as we all attended school as usual) I know severall families who did not have a single case of Yellow fever during the persistence of that disease in 1854. Sarah Cornwell's and severall others had black vomit who recovered and are still living —."), _c('sup', [_vm._v("2")])])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.15.1.0.box.375.309.1020.927.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.2.0.box.216.1306.1336.1090.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.2.0.box.226.1306.1320.158.q.60"
    }
  }, [_vm._v("She grew up with her mother's perseverance to survive, and a talent for dressmaking as an avocation. A strong independent nature emerged which would serve her well in life.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.2.1.box.225.1478.1321.325.q.60"
    }
  }, [_vm._v("The mother and daughter made a good living in the milinery business. It was Savannah's Golden Age in the 1830s, and many newcomers arrived in the city. Among them was a young Rhode Islander who had come South to seek his fortune in Savannah's commercial prosperity, and in March of 1837, Charlotte and John Henry Selah Branch were married.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.2.2.box.216.1827.1330.220.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.2.0"
    }
  }), _vm._v("To this union were born three sons. John Lufburrow was born on March 4, 1838, Sanford Walker on March 17, 1840, and Hamilton McDevit on March 17, 1843. It was a happy family, and John Branch's dry goods store made a comfortable living."), _c('sup', [_vm._v("3")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.2.3.box.225.2059.1327.337.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.3.0"
    }
  }), _vm._v("Then tragedy struck an early blow. John Branch died in 1846, at the age of 45, leaving Charlotte widowed with three little boys, the oldest of whom was only 10 years. She raised them with the help of her mother, providing a loving home and nurturing environment in an extended family atmosphere. Central to this was her Presbyterian faith that God would never give her anything she could not handle.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.217.306.1329.2096.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.0.box.219.306.1327.280.q.70"
    }
  }, [_vm._v("Widowed, Charlotte once again joined her mother in the milinery business. She was an active church member of Independent Presbyterian, and the boys were well behaved. They were the light of her life, and everyone commented on the happiness and pride they obviously brought their mother."), _c('sup', [_vm._v("4")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.218.600.1321.525.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.1.0"
    }
  }), _vm._v("John, as the oldest, was given preference for an education, and sent away to school in 1850. Charlotte instilled in him a keen sense of duty as the elder brother. \"When I look at you and think what a responsable situation you are placed in (that of an older brother) I allmost tremble for you,\" she wrote him at school. \"I know it is an arduous one, but then think what an honour to be guide to your two dear little brothers. What a comefort when you are a man (if God should spare your life) to think you have never set them a bad example.\""), _c('sup', [_vm._v("5")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.2.box.217.1138.1328.396.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.2.0"
    }
  }), _vm._v("In 1853, John entered the newly established Georgia Military Institute at Marietta, as a freshman cadet. His subjects were mathematics and engineering studies, to ensure a good job future. His younger brothers continued their education in the public schools of Savannah, at Chatham Academy. Though not given the opportunities that John received, Santy and Hammie were intelligent, hard working boys."), _c('sup', [_vm._v("6")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.3.box.218.1548.1321.397.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.3.0"
    }
  }), _vm._v("Charlotte kept them on the straight and narrow path between good and evil. Her letters to John while he was away at school, continually remind him about responsibility, \"to govern his passions,\" and \"remember the eye of God is on you in every"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.4.0"
    }
  }), _vm._v(" place.\" His behavior as a role model was constantly stressed. Through a mother's love and guidance, her fatherless children learned the meaning of honor, duty"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.5.0"
    }
  }), _vm._v(", principles — and love."), _c('sup', [_vm._v("7")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.4.box.218.1959.1326.443.q.60"
    }
  }, [_vm._v("In 1861, Charlotte was still the owner of a successful millinery business, in the three story house at 180 Broughton Street, enjoying much happiness with her boys, all three nearly grown to manhood. John had joined the Oglethorpe Light Infantry, a popu"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.6.0"
    }
  }), _vm._v("lar militia company in 1855. He was employed in the office of Padelford, Fay and Co., a cotton factor on Bay Street. Sanford, also in the O.L.I., worked as a druggist's clerk on Broughton Street, and baby brother Hamilton was a clerk at a shoe store."), _c('sup', [_vm._v("8")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.17.1.0.box.216.310.1321.1099.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.0.box.216.310.1321.272.q.60"
    }
  }, [_vm._v("Then the war came—in a feverish frenzy. When the Oglethorpe Light Infantry joined the Confederate Army, they were sent to the theatre of war in Virginia, and became Co. B, 8th Georgia Volunteer Infantry. Hamilton joined his brothers, and all three left their widowed mother.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.1.box.217.606.1320.151.q.60"
    }
  }, [_vm._v("Ever the doting mother, Charlotte worried and fretted that her influence could not survive the long distance separation. On July 15 she wrote to Sanford:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    attrs: {
      "id": "para.17.1.2.box.368.840.1019.569.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.0.0"
    }
  }), _vm._v("Mr. and Mrs. Hine will leve on Wednesday for Virginia—I envey them. I believe I am the only [Mother] who can't do as I would like. I wish I could be with you my own dear boys. I would be so much use. I could keep your clothes in order and make your meals so much better....I hope you are able to keep clean as I have just had a terrible account of the want of cleanliness in some of the regiments. It is worrying me for fear that you are suffering for want of change of apparel."), _c('sup', [_vm._v("9")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.2.0.box.217.1480.1327.915.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.2.0.box.217.1480.1327.335.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.3.0.0"
    }
  }), _vm._v("Charlotte threw herself into the activities of the various relief organizations formed by the women of Savannah to supply the soldiers she had sent to the front. Sewing circles met to make shirts, uniforms, socks and underclothing. Charlotte provided a quantity of blue checked material to make shirts for the company. She sewed four uniforms herself, and sent them along in a large box of provisions."), _c('sup', [_vm._v("10")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.2.1.box.217.1828.1321.266.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.3.1.0"
    }
  }), _vm._v("While the company was stationed in Virginia, John was promoted to Adjutant of the 8th Georgia. This necessitated buying a horse, and John was unable to obtain the funds. Charlotte borrowed enough money from a family friend to acquire the necessary mount for her officer son."), _c('sup', [_vm._v("11")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.2.2.box.218.2120.1320.275.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.3.2.0"
    }
  }), _vm._v("The 8th was ordered into battle at First Manassas on July 21, 1861, with all three Branch boys engaged. They were in the thickest of the fighting, where John was killed, Sanford taken prisoner, and Hamilton left to deal with the aftermath. He immediately telegraphed his mother with the sad tidings."), _c('sup', [_vm._v("12")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.217.309.1336.2085.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.0.box.225.309.1323.455.q.60"
    }
  }, [_vm._v("Charlotte was one of the first to receive the devastating news that every mother dreads. By the evening of July 22, she was on her way to Virginia by train, hoping desperately there was some mistake. When she arrived in Richmond, she pleaded for transportation to the battlefield, but General P.G.T. Beauregard had ordered no civilians be allowed to pass. Heartsick, she decided to stay with friends in Richmond for several days, where she was finally contacted by Hamilton. She set out to find him in camp near Manassas."), _c('sup', [_vm._v("13")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.1.box.217.777.1336.516.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.1.0"
    }
  }), _vm._v("Arriving at the hastily organized camp of the 8th Georgia, Charlotte was shocked by the state of things. The boys who had led such sheltered lives in Savannah were now dying, alone and far from home, of disease and wounds. She stayed with them, nursing some back to health, including her own son Hamilton, while she wrote letters attempting to learn some news of Sanford who had been captured. It was here that she earned her nickname, \"The Mother of the Oglethorpe Light Infantry\", staying for months while she made arrangements to have her oldest son John's remains disinterred and taken home."), _c('sup', [_vm._v("14")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.2.box.225.1306.1321.332.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.2.0"
    }
  }), _vm._v("From her quarters at Bristoe Station, Charlotte wrote her son Hamilton on August 26, \"I spent a dreadful night. It is so terable to see so many sick. Mrs. Bayard's nephew was very low and is near...They burried 2 the morning we left, they died during the night, disease in camp is dreadful, dreadful everywhere but worse there, with not a comfort around them, so little attention.\""), _c('span', {
    staticClass: "Apple-style-span",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.3.box.225.1656.1322.392.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.3.0"
    }
  }), _vm._v("While she tended others, her grief over her own sons was carried inside. Letters of condolence arrived at her temporary shelter, and remembrances of John's character were summed up by a family friend. \"If ever Savannah owned a young man of whom she might be justly proud, it was John Branch,\" wrote Correline West. \"For purity, industry, valor, truth and chivalry, surely of him most truly it might be said None saw him but to praise, None knew him but to love.\""), _c('sup', [_vm._v("16")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.4.box.227.2062.1321.332.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.4.0"
    }
  }), _vm._v("With John fell five other Savannah boys, all acquaintances. One of the fathers sent Charlotte a letter after they visited the graves of their sons together. Heman Crane had a remaining son in the O.L.I. \"Mrs. Branch,\" he wrote, \"allow me to commend to your care and kindness my dear son, my only son Horace — should he get sick again while you remain near the camp take him and care for him as"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.19.1.0.box.219.307.1320.106.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.0.0"
    }
  }), _vm._v("\nyou would for one of your own dear sons and the gratitude of a father and mother shall be poured out in humble prayer...\""), _c('sup', [_vm._v("17")])])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.1.0.box.218.307.1323.2084.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.1.box.219.426.1320.279.q.60"
    }
  }, [_vm._v("Charlotte remained at Bristoe Station until just before Christmas when, heartbroken, she left Hammie and returned to Savannah. On December 20, Sanford was released from Old Capital Prison, where he had been held since July 21. His mother had never ceased to effect his release, contacting influential people in Washington, D.C.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.2.box.220.717.1320.220.q.60"
    }
  }, [_vm._v("But she had been unable to secure a furlough for Hammie. In February 1862, John's body was disinterred and returned to Savannah. He was buried beside his father in Laurel Grove Cemetery on February 9."), _c('sup', [_vm._v("18")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.3.box.220.950.1321.500.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.3.0"
    }
  }), _vm._v("Sanford was paroled and returned to his regiment in June 1862. Hamilton's one year enlistment ended in May, and he came home to Savannah. Seeing his mother's grief over John's death, and Sanford's return to Virginia, Hammie reenlisted in a local company of militia. The Savannah Cadets was composed of boys too young for the regular army. Hammie was a veteran at age nineteen, and was offered a commission as first lieutenant. He accepted so he could be stationed nearer his mother. The Cadets spent 1862 and 1863 at the coastal batteries around Savannah and South Carolina."), _c('sup', [_vm._v("19")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.4.box.218.1472.1322.451.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.4.0"
    }
  }), _vm._v("The hardships of the war hounded Charlotte just as they did women in every part of the Confederacy. Shortages of food, financial reversals, and her continual sacrifices for her sons' comfort in the field became her daily struggles. Her mother died in October 1862, and with both remaining sons in danger, she refused to be idle. Instead, she immersed herself in war work, whether sewing shirts and socks, packing boxes of food to send to hungry soldiers, or nursing in the hospitals around Savannah.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.5.box.219.1937.1320.222.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.5.0"
    }
  }), _vm._v("Both boys were now lieutenants, but Sanford remained in the 8th Georgia. \"You can see by the heading of this letter that we are in the Union again,\" he wrote to his mother on June 28, 1863, from an army camp outside Chambersburg, Pennsylvania."), _c('sup', [_vm._v("20")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.6.box.218.2171.1321.220.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.6.0"
    }
  }), _vm._v("When Charlotte opened the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Savannah ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Daily ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("News ")]), _vm._v("on July 6, she relived a nightmare. There had been a great battle at a town called Gettysburg. Listed under the casualties from the Savannah companies was \"Lt. Sanford W. Branch, shot through lungs—feared mortally.\""), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.1.0.box.220.303.1321.525.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("\nToo distraught to stay at home, she once again set out for Virginia, and General Lee's Army. After arriving in Richmond, she began contacting officials for passes. She traveled to Staunton, then Winchester, and made her way to Bunker Hill before she learned that her son was once again a prisoner. He had been too severely injured to be moved from the field hospital when the Confederate army retreated. Every last ounce of her mother's love was poured into pleading to gain permission to enter Federal lines. She pulled every string she could, contacting Savannah politicians, and Confederate Army officials."), _c('sup', [_vm._v("21")])])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.1.0.box.220.303.1321.644.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.1.box.221.841.1318.106.q.50"
    }
  }, [_vm._v("On July 15, Brig. Gen. Alexander R. Lawton sent a letter to Gen. Robert E. Lee on Charlotte's behalf, with the following request:")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-left": "3em",
      "margin-right": "3em"
    },
    attrs: {
      "id": "block.20.2.0.box.368.1019.1021.1154.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.20.2.0.box.1096.1019.290.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _vm._v("Richmond, Va.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.20.2.1.box.1162.1079.226.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.1.0"
    }
  }), _vm._v("15th July 63")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.2.2.box.371.1137.153.33.q.90"
    }
  }, [_vm._v("General")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.2.3.box.368.1196.1021.690.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.2.0"
    }
  }), _vm._v("I take the liberty of sending you this note by Mrs. Branch of Savannah Geo, whose son was seriously wounded in the recent battle in Pennsylvania — Mrs. Branch earnestly desires to reach and minister to her son; and her case appeals strongly to every heart Mrs. Branch has given three sons to our service — one of them was killed at Manassas, another is now facing the enemy at Charleston, and I trust she will be permitted to wait at the couch of the third, who so much needs her services—I beg that any officer to whom this letter may be shown, will assist this excellent lady and widowed mother in reaching her son.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right",
      "margin-left": "0"
    },
    attrs: {
      "id": "para.20.2.4.box.1009.1900.379.99.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.4.0"
    }
  }), _vm._v("I am, General, very respectfully")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.20.2.5.box.1066.2013.321.33.q.80"
    }
  }, [_vm._v("Yr. Obt. Servant")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.20.2.6.box.1136.2071.251.34.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.5.0"
    }
  }), _vm._v("A.R. Lawton")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.20.2.7.box.1145.2124.241.49.q.50"
    }
  }, [_vm._v("Brig. Genl."), _c('sup', [_vm._v("22")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.3.0.box.216.2242.1322.161.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.3.0.box.368.2242.468.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0"
    }
  }), _vm._v("The request was denied.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.3.1.box.216.2301.1322.102.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.1.0"
    }
  }), _vm._v("Soon a letter was received reassuring her that Sanford would live. She would not see him again for eighteen months, while he spent"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.1.0.box.216.309.1321.103.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _vm._v("\nthe harshest part of his experience as a Confederate soldier—in Yankee prisons.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.1.0.box.216.309.1330.2084.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.218.426.1319.453.q.60"
    }
  }, [_vm._v("Charlotte returned to Georgia, where Hamilton was still doing duty around Savannah. When Union Maj. Gen. William T. Sherman invaded the state in May 1864, Hamilton's regiment was sent to Dalton, where the Army of Tennessee would be the front line defenders for the next year. Once again a son was standing between the enemy and home. While she continued to seek an exchange for Sanford, Charlotte spent her days nursing in Confederate hospitals in Marietta and Atlanta, to be near the front."), _c('sup', [_vm._v("23")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.217.896.1326.338.q.60"
    }
  }, [_vm._v("Hamilton was wounded on July 24, following the Battle of Atlanta. He met his mother at the hospital, where he received a thirty day furlough home. He and his mother returned to Savannah, but his patriotism would not let him remain out of action while his men were engaged. He went back to the army and was again slightly wounded in September.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.3.box.219.1247.1326.378.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0"
    }
  }), _vm._v("Hamilton arrived back with his company just as the Army of Tennessee embarked on Hood's ill-fated campaign into Tennessee to attack the Union Army at Nashville. The Savannah Cadets were detailed as part of the army rear guard with the cavalry, under Gen. Nathan Bedford Forrest. After Hood's defeat, they covered the Confederate retreat back into Alabama, ragged, hungry boys amid the ice and snow of November.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.4.box.219.1649.1327.744.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.4.0"
    }
  }), _vm._v("The strain of the war and the threat to her family became more difficult to live with. Sanford was finally released from prison on December 5, 1864, after spending three months as one of The Immortal Six Hundred, held under the crossfire of Union and Confederate artillery. When he returned home, Charlotte was sickened at the change wrought by his ordeal. Underweight, nearly starved, and still coughing up blood from his unhealed lung, he was hardly recognizable as the boy she had sent to war. Three weeks later, Savannah fell to Sherman's occupation, and the quest for independence, in which the Branch family had invested so precious a part of itself, was lost. An especially cruel blow was the Union orders that all families of Confederate officers must leave the town. Charlotte became one of many displaced families by this act."), _c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0"
    }
  }), _vm._v("24")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.1.0.box.217.302.1329.2071.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.0.box.217.302.1329.500.q.60"
    }
  }, [_vm._v("Allowed to take only one horse and wagon containing what provisions were necessary, she and Sanford loaded as much as they could, and moved out into Effingham County, while Hamilton continued with the Confederate Army as it attempted to join Gen. Joseph Johnston in North Carolina. But he was too broken down in health to keep up, and arrived at the Confederate hospital in Augusta, Georgia in February 1865. Here he was quartered in a private house, and slowly improved. After a short time of duty sending furloughed men back to the army, he returned home in May. The war was over."), _c('sup', [_vm._v("25")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.1.box.224.813.1320.270.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0"
    }
  }), _vm._v("The post-war years presented new difficulties for Charlotte. She had lost her home, her business, and her security. Nearly destitute, she was forced to join the Needle Woman's Friend, a society for the poor. Women sewed and mended clothing, and the items were sold as a charity for the makers. In this way, she earned a meagre living.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.2.box.222.1094.1323.887.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.2.0"
    }
  }), _vm._v("John's death had left an unfilled void in her life, but with a purpose. It convinced her that the sons of the South must never be forgotten. She was among the founding members of the Ladies' Memorial Association in Savannah, calling the first meeting in 1867. Each year the graves of Savannah's slain were lovingly decorated, and memorial services held. July 21 was chosen as an annual day to commemorate those killed at First Manassas. Her two remaining sons also became active in Veterans' organizations, and with the reorganized militias of the Oglethorpe Light Infantry and Savannah Cadets. Their mother was never forgotten by the veterans as the Mother of the Oglethorpe Light Infantry from their boyhood. She was the custodian of their flag, which was kept in a locked trunk along with John's uniforms and sword. On each July 21, when the company mustered for their annual ceremony, they marched to her house with much pomp and circumstance to receive the flag. At the end of the day, it was returned reverently to the trunk of memories."), _c('sup', [_vm._v("26")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.3.box.221.1991.1322.382.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.3.0"
    }
  }), _vm._v("Charlotte Branch never attained any notable fame in her state, or even in her hometo"), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  }), _vm._v("wn. She died at age 80, from a fall in her bedroom, still belov"), _c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _vm._v("ed by the men who remembered her sacrifices during the war. But perhaps more than any women whose diaries are now well-known, or deeds recounted, she represents the majority. Like thousands"), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v(" of Southern women, she sent to the war her most prized possessions—her sons.")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.23.0.0.box.218.400.1334.1692.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0007.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.1.0.box.216.306.1333.1991.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.24.1.0.box.813.306.148.41.q.80"
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.1.box.228.428.1319.111.q.50"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v(" Margaret Branch Sexton Letters. Ms. 25, Box 1-4. Hargrett Library. University of Georgia, Athens.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.2.box.218.608.1327.111.q.40"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.0.0"
    }
  }), _vm._v("2")]), _vm._v(" Ibid. Undated letter of Charlotte Branch to Hamilton Branch, c. July 1861.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.3.box.226.788.1323.156.q.40"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.4.0.0"
    }
  }), _vm._v("3")]), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.5.0.0"
    }
  }), _vm._v(" Mauriel P. Joslyn. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlotte's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boys: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Wartime ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Correspondence ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Branch ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Family ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Savannah, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1861-1865. ")]), _vm._v("Rockbridge Press, Berryville, Va. 1996. 5-7.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.4.box.226.1022.117.39.q.40"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.6.0.0"
    }
  }), _vm._v("4")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.5.box.217.1144.1329.104.q.50"
    }
  }, [_c('span', {
    staticClass: "Apple-style-span",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.7.0.0"
    }
  }), _vm._v("5")]), _vm._v(" Sexton Letters. Box 1, folder 1. Charlotte Branch to John Branch January 8, 1850.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.6.box.226.1316.554.50.q.40"
    }
  }, [_c('sup', [_vm._v("6")]), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.8.0.0"
    }
  }), _vm._v(" Joslyn, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlotte's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boys, ")]), _vm._v("8-10.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.7.box.216.1435.1329.108.q.40"
    }
  }, [_c('sup', [_vm._v("7")]), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.9.0.0"
    }
  }), _vm._v(" Sexton Letters. Box 1, folder 1. Charlotte Branch to John Branch January 8, 1850")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.8.box.225.1609.1320.97.q.60"
    }
  }, [_c('sup', [_vm._v("8")]), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.10.0.0"
    }
  }), _vm._v(" Savannah City Directory 1860; Chatham County, Georgia Census 1860.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.9.box.225.1783.1318.107.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.11.0.0"
    }
  }), _vm._v("9")]), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.12.0.0"
    }
  }), _vm._v(" Sexton Letters. Charlotte Branch to Sanford Branch, July 15, 1861. Box 1, folder 1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.10.box.228.1957.590.47.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.13.0.0"
    }
  }), _vm._v("10")]), _vm._v(" Joslyn, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlotte's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boys, ")]), _vm._v("21-22.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "para.24.1.11.box.224.2071.1318.101.q.60"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.14.0.0"
    }
  }), _vm._v("11")]), _vm._v("Sexton Letters. John Branch to Charlotte Branch, June 14, 1861. Box 1, folder 1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.12.box.230.2246.588.51.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.16.0.0"
    }
  }), _vm._v("12")]), _vm._v(" Joslyn. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlotte's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boys, ")]), _vm._v("57-59.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.218.307.1322.1855.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%"
    },
    attrs: {
      "id": "para.25.1.0.box.221.307.279.48.q.50"
    }
  }, [_c('sup', [_vm._v("13")]), _c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0"
    }
  }), _vm._v(" Ibid., 68-69.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%"
    },
    attrs: {
      "id": "para.25.1.1.box.221.425.279.47.q.50"
    }
  }, [_c('sup', [_vm._v("14")]), _vm._v(" Ibid., 83-86.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.2.box.221.542.1314.107.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.0.0"
    }
  }), _vm._v("15")]), _vm._v(" Sexton Letters. Charlotte Branch to Hamilton Branch, Aug. 26, 1861. Box 1, folder 1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.3.box.218.719.1318.99.q.40"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0"
    }
  }), _vm._v("16")]), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.1.0"
    }
  }), _vm._v(" Ibid., Correline West to Charlotte Branch, Aug. 29, 1861. Box 1, folder 1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.4.box.222.896.1316.104.q.40"
    }
  }, [_c('sup', [_vm._v("17")]), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.0.0"
    }
  }), _vm._v(" Ibid., Heman A. Crane to Charlotte Branch, Nov. 27, 1861. Box 1, folder 1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.5.box.223.1070.833.50.q.60"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.7.0.0"
    }
  }), _vm._v("18")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Savannah ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Morning ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("News, ")]), _vm._v("February 3, 1862.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.6.box.222.1186.638.51.q.60"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.8.0.0"
    }
  }), _vm._v("19")]), _vm._v("Joslyn, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlotte's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boys, ")]), _vm._v("157-158.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.7.box.219.1302.1318.102.q.60"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.9.0.0"
    }
  }), _vm._v("20")]), _vm._v(" Sexton Letters. Sanford Branch to Charlotte Branch, June 28, 1863. Box 1, folder 4.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.8.box.219.1472.829.51.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.10.0.0"
    }
  }), _vm._v("21")]), _vm._v(" Ibid. Correspondence in Box 1, folder 5.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.9.box.220.1591.1320.105.q.40"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.11.0.0"
    }
  }), _vm._v("22")]), _vm._v(" Ibid. Brig. Gen. Alexander R. Lawton to Gen. Robert E. Lee, July 15, 1863. Box 1, folder 5.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.10.box.219.1765.642.50.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.12.0.0"
    }
  }), _vm._v("23")]), _vm._v("Joslyn, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlotte's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boys, ")]), _vm._v("291-293.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.11.box.220.1880.1169.51.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.13.0.0"
    }
  }), _vm._v("24")]), _vm._v(" Sexton Letters. Correspondence in Box 2, folders 1 and 4.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.12.box.220.1995.458.47.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.14.0.0"
    }
  }), _vm._v("25")]), _vm._v(" Ibid., Box 2, folder 4.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.13.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.25.1.13.box.220.2112.641.50.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.15.0.0"
    }
  }), _vm._v("26")]), _vm._v("Joslyn, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Charlotte's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boys, ")]), _vm._v("445-447.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9676f42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0008.vue
// module id = 60
// module chunks = 0